<script lang="ts">import { BaseParticle } from "components/cards/particles";
import "./spec";
import { getTranslator } from "components/cards/utilities";
import { afterUpdate, onMount } from "svelte";
// props
export let container = undefined;
export let name = "";
export let source = "";
export let translations = [];
export let noDefaultStyling = false;
export let noAutoHeight = false;
export let passThroughQueryParams = false;
// inputs
export let _block = false;
$: xlator = getTranslator(translations, { source });
$: styles = {};
let iframeContainerEl = null;
let iframeEl = null;
onMount(() => {
    var _a;
    if (iframeContainerEl && iframeEl) {
        window.removeEventListener('message', iframeEl._ycResizeListener, false);
        iframeEl._ycResizeListener = function (event) {
            if (!event.data || event.data.event !== 'WEBVIEW_RESIZE')
                return;
            if (event.source !== iframeEl.contentWindow)
                return;
            const newHeight = event.data.height;
            if (!noAutoHeight && typeof newHeight === 'number' && newHeight > 0) {
                iframeContainerEl.style.height = newHeight + 'px';
                iframeEl.style.height = '100%';
            }
        };
        window.addEventListener('message', iframeEl._ycResizeListener, false);
        (_a = iframeEl.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage({ event: 'WEBVIEW_GETSIZE' }, '*');
    }
    return () => {
        if (iframeEl && iframeEl._ycResizeListener) {
            window.removeEventListener('message', iframeEl._ycResizeListener, false);
            iframeEl._ycResizeListener = null;
        }
    };
});
let previousSource = "";
afterUpdate(() => {
    if (iframeEl && previousSource !== source) {
        previousSource = source;
        // Reset height when source changes
        if (!noAutoHeight) {
            iframeEl.style.height = 'auto';
        }
    }
});
$: modifiedSource = (function (source, passThroughQueryParams) {
    let url = xlator({ source });
    if (passThroughQueryParams) {
        const currentUrl = new URL(window.location.href);
        const sourceUrl = new URL(url, currentUrl.origin);
        currentUrl.searchParams.forEach((value, key) => {
            if (!sourceUrl.searchParams.has(key)) {
                sourceUrl.searchParams.append(key, value);
            }
        });
        url = sourceUrl.toString();
    }
    return url;
})(source, passThroughQueryParams);
</script>

<style>
  .iframe-container, .iframe-container > iframe {
    width: 100%;
  }

  .iframe-container > iframe {
    height: 100%;
  }

  .iframe-container > iframe:not(.no-default-styling) {
    min-height: 15rem;
    aspect-ratio: 16/9;
  }</style>

<BaseParticle _name="WebEmbedParticle" _inline={!_block} _cssVariablePrefix="web-embed-particle" {...container} {...styles} >
  <div bind:this={iframeContainerEl} class="iframe-container">
    <iframe bind:this={iframeEl} title={name} class:no-default-styling={noDefaultStyling} src={modifiedSource} style="border: none;" allowfullscreen
      sandbox="allow-scripts allow-presentation allow-same-origin allow-forms"
      allow="autoplay; fullscreen; picture-in-picture; xr-spatial-tracking; clipboard-write">
    </iframe>
  </div>
</BaseParticle>
